<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div
    v-dragscroll
    :style="{gridGap:gap}"
    style="overflow-x: scroll;
     display: grid;grid-auto-flow: column;grid-auto-columns: max-content"
  >
    <slot />
  </div>
</template>

<script>
import { dragscroll } from 'vue-dragscroll/src/main'

export default {
  name: 'HorizontalList',
  directives: {
    dragscroll
  },
  props: {
    gap: {
      default: '8px'
    }
  }
}
</script>

<style scoped>

</style>
